export default __webpack_public_path__ + "static/media/surveys.95cad98f.svg";